export function Logo({ compact = false, hero = false }: { compact?: boolean; hero?: boolean }) {
  const height = hero ? 'h-11' : 'h-9'

  if (compact) {
    return (
      <span className={`inline-block overflow-hidden ${height} ${hero ? 'w-10' : 'w-8'}`}>
        <img
          src="/racunko-logo.webp"
          width="713"
          height="237"
          alt="Računko AI"
          className="block h-full w-auto max-w-none"
        />
      </span>
    )
  }

  return (
    <img
      src="/racunko-logo.webp"
      width="713"
      height="237"
      alt="Računko AI"
      className={`block w-auto ${height}`}
    />
  )
}
